import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import ProductCard from '../components/ProductCard';
import './HomePage.css';

const CATEGORIES = [
  { label: 'Bracelets', value: 'bracelets', emoji: '✨' },
  { label: 'Necklaces', value: 'necklaces', emoji: '💫' },
  { label: 'Rings', value: 'rings', emoji: '💍' },
  { label: 'Hand Chains', value: 'hand-chains', emoji: '⛓️' },
];

const HomePage = () => {
  const [featured, setFeatured] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeatured = async () => {
      try {
        const res = await api.get('/products?featured=true&limit=8');
        setFeatured(res.data.products);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchFeatured();
  }, []);

  return (
    <div className="home">
      {/* Hero */}
      <section className="hero">
        <div className="hero__content">
          <p className="hero__eyebrow">New Collection 2026</p>
          <h1 className="hero__title">Wear What<br /><em>Speaks to You</em></h1>
          <p className="hero__desc">Premium fashion jewellery designed for the bold and the beautiful. Bracelets, necklaces, rings & hand chains.</p>
          <div className="hero__actions">
            <Link to="/shop" className="btn btn-primary btn-lg">Shop Now</Link>
            <Link to="/shop?sale=true" className="btn btn-outline-gold btn-lg">View Sale</Link>
          </div>
        </div>
        <div className="hero__visual">
          <div className="hero__image-stack">
            <img src="https://res.cloudinary.com/dx73afa7f/image/upload/v1778957818/AD0B6275-51E9-43B3-A4F4-2841D2C9EFCC_xx7igf.jpg" alt="Premium Jewellery" className="hero__img-main" />
            <div className="hero__badge">
              <span>✦</span>
              <p>Handcrafted</p>
              <p>Jewellery</p>
            </div>
          </div>
        </div>
      </section>

      {/* Marquee */}
      <div className="marquee-strip">
        <div className="marquee-track">
          {['Free Shipping above ₹499', '✦', 'Easy Returns', '✦', 'Secure Payments', '✦', 'Cash on Delivery Available', '✦'].concat(['Free Shipping above ₹499', '✦', 'Easy Returns', '✦', 'Secure Payments', '✦', 'Cash on Delivery Available', '✦']).map((item, i) => (
            <span key={i}>{item}</span>
          ))}
        </div>
      </div>

      {/* Categories */}
      <section className="section">
        <div className="container">
          <p className="section-subtitle">Explore by Category</p>
          <h2 className="section-title">Shop the Collection</h2>
          <div className="gold-line" />
          <div className="categories-grid">
            {CATEGORIES.map((cat) => (
              <Link to={`/shop?category=${cat.value}`} key={cat.value} className="category-card">
                <div className="category-card__icon">{cat.emoji}</div>
                <h3>{cat.label}</h3>
                <span className="category-card__link">Shop Now →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Products */}
      <section className="section" style={{ background: 'var(--cream)' }}>
        <div className="container">
          <p className="section-subtitle">Hand Picked</p>
          <h2 className="section-title">New Arrivals</h2>
          <div className="gold-line" />
          {loading ? (
            <div className="loading-spinner"><div className="spinner" /></div>
          ) : featured.length > 0 ? (
            <div className="grid-4">
              {featured.map((p) => <ProductCard key={p._id} product={p} />)}
            </div>
          ) : (
            <div className="empty-state">
              <h3>Products Coming Soon</h3>
              <p>We're adding our beautiful collection. Check back shortly!</p>
            </div>
          )}
          <div style={{ textAlign: 'center', marginTop: '48px' }}>
            <Link to="/shop" className="btn btn-primary">View All Products</Link>
          </div>
        </div>
      </section>

      {/* Brand Promise */}
      <section className="section promises-section">
        <div className="container">
          <div className="promises-grid">
            {[
              { icon: '🚚', title: 'Free Shipping', desc: 'On orders above ₹499' },
              { icon: '🔒', title: 'Secure Payment', desc: 'Razorpay encrypted checkout' },
              { icon: '↩️', title: 'Easy Returns', desc: '7-day hassle free returns' },
              { icon: '⭐', title: 'Premium Quality', desc: 'Curated fashion jewellery' },
            ].map((p) => (
              <div key={p.title} className="promise-card">
                <span className="promise-icon">{p.icon}</span>
                <h4>{p.title}</h4>
                <p>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
